import { getLabel } from "../../../../../../../hooks/use-labels";
import { getStyle } from "../../../../../../../hooks/use-styles";
import { getStorageItem } from "../../../../../../../utils/common-utils";
import { formatSlotTime } from "../../delivery-type-card-utils";

export const prepareViewDetails = (deliveryType) => {
  const { scheduled, consumerPickup, express, standard, free, timelineSlot } =
    deliveryType;

  let typeName = "";
  typeName = scheduled ? "scheduled" : typeName;
  typeName = consumerPickup ? "selfPickup" : typeName;

  typeName = standard ? "standard" : typeName;
  typeName = express ? "express" : typeName;
  typeName = free ? "free" : typeName;

  let typeDetails = typeDetailsContent[typeName];

  if (scheduled) {
    typeDetails = formatTimeSlotType(typeDetails, timelineSlot);
  } else if (consumerPickup) {
    typeDetails = formatTimeSlotType(typeDetails, timelineSlot);
  } else {
    typeDetails = formatStandardExpressType(typeDetails, deliveryType);
  }

  return typeDetails;
};

const formatStandardExpressType = (details, type) => {
  let typeDetails = { ...details };
  const formattedSpan = formatTypeSpanText(type);
  const { valueText } = typeDetails;

  typeDetails = {
    ...typeDetails,
    valueText: (
      <div>
        {valueText}
        <span className="weight-500 ml-4" style={{ color: getStyle("black") }}>
          {formattedSpan}
        </span>
      </div>
    ),
  };

  return typeDetails;
};

const formatTimeSlotType = (details, selectedSlot) => {
  let typeDetails = { ...details };
  typeDetails = {
    ...typeDetails,
    ...(selectedSlot && {
      valueText: `Delivery on - ${formatSlotTime(selectedSlot)}`,
    }),
  };

  return typeDetails;
};

export const formatTypeSpanText = ({ minSpan, maxSpan, spanType }) => {
  const spanText = {
    H: `${minSpan} to ${maxSpan} hours`,
    D: `${minSpan} to ${maxSpan} days`,
  };

  return spanText[spanType];
};

const typeDetailsContent = {
  standard: {
    description: getLabel("standardDescription"),
    valueText: getLabel("deliveryInLabel"),
    image: `/assets/icons/shopping-cart/delivery-van.svg`,
  },
  express: {
    description: getLabel("expressDescription"),
    valueText: getLabel("deliveryInLabel"),
    image: `/assets/icons/shopping-cart/delivery-van.svg`,
  },
  free: {
    description: getLabel("freeDescription"),
    valueText: getLabel("deliveryInLabel"),
    image: `/assets/icons/shopping-cart/delivery-van.svg`,
  },
  scheduled: {
    description: getLabel("scheduledDescription"),
    valueText: getLabel("selectTimelineLabel"),
    image: `/assets/icons/shopping-cart/clock.svg`,
  },
  selfPickup: {
    description: getLabel("selfPickupDescription"),
    valueText: getLabel("deliveryDateAndTimeLabel"),
    image: `/assets/icons/shopping-cart/clock.svg`,
  },
};

export const getUnsupportedProducts = (unsupportedIds) => {
  const carts = getStorageItem("carts");
  const unsupportedProducts = [];

  unsupportedIds.forEach((id, key) => {
    const product = carts.cartProducts.find(
      ({ product }) => product.id === id
    ).product;

    unsupportedProducts.push({
      label: product.name,
      key,
      icon: (
        <img
          src={product.imageUrls[0]}
          alt="product-name"
          key={key}
          className="unsupported-image"
        />
      ),
    });
  });

  return unsupportedProducts;
};
